import { render, staticRenderFns } from "./PayerUnderpayments.vue?vue&type=template&id=a391845c&scoped=true&"
import script from "./PayerUnderpayments.vue?vue&type=script&lang=js&"
export * from "./PayerUnderpayments.vue?vue&type=script&lang=js&"
import style0 from "./PayerUnderpayments.vue?vue&type=style&index=0&id=a391845c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a391845c",
  null
  
)

export default component.exports